import MessageDialog from './src/main'

export default {
  install(Vue, options) {
    Vue.prototype.$messageDialog = MessageDialog
  }
}

